/* eslint-disable */

const DhdStatesPricing = [
  {
    wilaya_code: "01",
    name: "أدرار",
    price: 1100,
    stopdesk: "مكتب أدرار",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "02",
    name: "الشلف",
    price: 700,
    stopdesk: "مكتب الشلف",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "03",
    name: "الأغواط",
    price: 900,
    stopdesk: "مكتب الأغواط",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "04",
    name: "أم البواقي",
    price: 800,
    stopdesk: "مكتب أم البواقي",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "05",
    name: "باتنة",
    price: 800,
    stopdesk: "مكتب باتنة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "06",
    name: "بجاية",
    price: 700,
    stopdesk: "مكتب بجاية",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "07",
    name: "بسكرة",
    price: 900,
    stopdesk: "مكتب بسكرة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "08",
    name: "بشار",
    price: 1100,
    stopdesk: "مكتب بشار",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "09",
    name: "البليدة",
    price: 500,
    stopdesk: "مكتب البليدة",
    pricestopdesk: 250,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "10",
    name: "البويرة",
    price: 650,
    stopdesk: "مكتب البويرة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "11",
    name: "تمنراست",
    price: 1300,
    stopdesk: "مكتب تمنراست",
    pricestopdesk: 800,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "12",
    name: "تبسة",
    price: 800,
    stopdesk: "مكتب تبسة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "13",
    name: "تلمسان",
    price: 800,
    stopdesk: "مكتب تلمسان",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "14",
    name: "تيارت",
    price: 800,
    stopdesk: "مكتب تيارت",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "15",
    name: "تيزي وزو",
    price: 650,
    stopdesk: "مكتب تيزي وزو",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "16",
    name: "الجزائر",
    price: 400,
    stopdesk: "مكتب الجزائر",
    pricestopdesk: 200,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "17",
    name: "الجلفة",
    price: 900,
    stopdesk: "مكتب الجلفة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "18",
    name: "جيجل",
    price: 700,
    stopdesk: "مكتب جيجل",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "19",
    name: "سطيف",
    price: 700,
    stopdesk: "مكتب سطيف",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "20",
    name: "سعيدة",
    price: 800,
    stopdesk: "مكتب سعيدة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "21",
    name: "سكيكدة",
    price: 700,
    stopdesk: "مكتب سكيكدة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "22",
    name: "سيدي بلعباس",
    price: 700,
    stopdesk: "مكتب سيدي بلعباس",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "23",
    name: "عنابة",
    price: 700,
    stopdesk: "مكتب عنابة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "24",
    name: "قالمة",
    price: 800,
    stopdesk: "مكتب قالمة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "25",
    name: "قسنطينة",
    price: 700,
    stopdesk: "مكتب قسنطينة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "26",
    name: "المدية",
    price: 600,
    stopdesk: "مكتب المدية",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "27",
    name: "مستغانم",
    price: 700,
    stopdesk: "مكتب مستغانم",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "28",
    name: "المسيلة",
    price: 800,
    stopdesk: "مكتب المسيلة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "29",
    name: "معسكر",
    price: 700,
    stopdesk: "مكتب معسكر",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "30",
    name: "ورقلة",
    price: 900,
    stopdesk: "مكتب ورقلة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "31",
    name: "وهران",
    price: 700,
    stopdesk: "مكتب وهران",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "32",
    name: "البيض",
    price: 1000,
    stopdesk: "مكتب البيض",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "33",
    name: "إليزي",
    price: 1300,
    stopdesk: "مكتب إليزي",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "34",
    name: "برج بوعريريج",
    price: 700,
    stopdesk: "مكتب برج بوعريريج",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "35",
    name: "بومرداس",
    price: 600,
    stopdesk: "مكتب بومرداس",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "36",
    name: "الطارف",
    price: 800,
    stopdesk: "مكتب الطارف",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "37",
    name: "تندوف",
    price: 1300,
    stopdesk: "مكتب تندوف",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "38",
    name: "تيسمسيلت",
    price: 800,
    stopdesk: "مكتب تيسمسيلت",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "39",
    name: "الوادي",
    price: 900,
    stopdesk: "مكتب الوادي",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "40",
    name: "خنشلة",
    price: 800,
    stopdesk: "مكتب خنشلة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "41",
    name: "سوق أهراس",
    price: 800,
    stopdesk: "مكتب سوق أهراس",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "42",
    name: "تيبازة",
    price: 600,
    stopdesk: "مكتب تيبازة",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "43",
    name: "ميلة",
    price: 700,
    stopdesk: "مكتب ميلة",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "44",
    name: "عين الدفلى",
    price: 600,
    stopdesk: "مكتب عين الدفلى",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "45",
    name: "النعامة",
    price: 1000,
    stopdesk: "مكتب النعامة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "46",
    name: "عين تموشنت",
    price: 700,
    stopdesk: "مكتب عين تموشنت",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "47",
    name: "غرداية",
    price: 900,
    stopdesk: "مكتب غرداية",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "48",
    name: "غليزان",
    price: 700,
    stopdesk: "مكتب غليزان",
    pricestopdesk: 400,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "49",
    name: "تيميمون",
    price: 1300,
    stopdesk: "مكتب تيميمون",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "51",
    name: "أولاد جلال",
    price: 900,
    stopdesk: "مكتب أولاد جلال",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "52",
    name: "بني عباس",
    price: 1300,
    stopdesk: "مكتب بني عباس",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: false,
  },
  {
    wilaya_code: "53",
    name: "عين صالح",
    price: 1300,
    stopdesk: "مكتب عين صالح",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "55",
    name: "تقرت",
    price: 900,
    stopdesk: "مكتب تقرت",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "57",
    name: "المغير",
    price: 900,
    stopdesk: "مكتب المغير",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: false,
  },
  {
    wilaya_code: "58",
    name: "المنيعة",
    price: 1000,
    stopdesk: "مكتب المنيعة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
];

export default DhdStatesPricing;
